exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.categoriesArea[data-v-6af92c90] {\n  margin: 0 auto;\n  width: 500px;\n  column-count: 3;\n  column-gap: 10px;\n}\n.categoriesArea .categoriesHolder[data-v-6af92c90] {\n    width: 100%;\n    margin: 10px 0;\n    display: inline-block;\n    box-sizing: border-box;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-6af92c90","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/widget/widgetComposer.vue
// module id = 2523
// module chunks = 0